import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { ServiceActivityResponseDataType } from '../@types';
import { getServiceActivityMonitorData } from '../api/services';
import { ServiceActivityMonitorKey } from '../configs/services';
import { REFRESH_INTERVAL_MS } from '../constants/service-activity.constant';

export const useGetServiceActivityMonitorData = (
  refreshEnabled: boolean
): UseQueryResult<ServiceActivityResponseDataType[]> => {
  return useQuery({
    queryKey: [ServiceActivityMonitorKey],
    queryFn: () => getServiceActivityMonitorData(),
    // Shared with the header's "every 120s" label so the two cannot drift.
    refetchInterval: refreshEnabled ? REFRESH_INTERVAL_MS : false,
  });
};
